// extracted by mini-css-extract-plugin
export default {"app":"FriendsIcon_app__dVFpW","peoples":"FriendsIcon_peoples__m6ucG","more":"FriendsIcon_more__+RTCa","add":"FriendsIcon_add__rmhf4"};